import { of } from 'rxjs'
import { switchMap, take } from 'rxjs/operators'

import { AuditCampaign, getTranslatedString } from '@skinsoft/types'
import { auditCampaignSelectors, thesaurusTermSelectors } from '@skinsoft/selectors'
import { STATS_KEYS } from '../dexie/stats-keys'
import { dbCacheDown } from '../dexie/cache-down'
import { OfflineDataFetcher } from '../offline-data-fetcher'
import { ThesaurusTermOfflineDataFetcher } from './thesaurus-term-offline-data-fetcher'
import { matchesRegex } from '@skinsoft/utils'

export class AuditCampaignOfflineDataFetcher extends OfflineDataFetcher<AuditCampaign>{
    constructor() {
        super(dbCacheDown.auditCampaign, STATS_KEYS.auditCampaign)
    }

    protected async queryTextFilter(entity: AuditCampaign, queryText: string, locale: string): Promise<boolean> {
        const lowerCaseQueryText: string = queryText.toLowerCase()

        // campaign title
        // `as` (not `:`) is required here: lodash's `get()` infers `never` for this dynamic-locale
        // path, and a plain type annotation keeps that `never` for control-flow narrowing below,
        // while an `as` cast makes `title` genuinely behave as `string | undefined` afterwards.
        const title = auditCampaignSelectors.title(entity, locale) as string | undefined
        const titleMatch = title ? matchesRegex(lowerCaseQueryText, title.toLowerCase()) : false

        // campaign number
        const refNumber: string | undefined = auditCampaignSelectors.identificationNumber(entity);
        // @ts-ignore
        const refNumberMatch = refNumber ? matchesRegex(lowerCaseQueryText, refNumber.toLowerCase()) : false

        // campaign number
        // @ts-ignore
        const campaignTypeId: string | undefined = auditCampaignSelectors.auditType(entity)
        // @ts-ignore
        const campaignType: string = await new ThesaurusTermOfflineDataFetcher().fetchOneFromId(campaignTypeId)
            .pipe(
                take(1),
                switchMap(
                    term => {
                        if(term) {
                            return of(getTranslatedString(thesaurusTermSelectors.preferredTerm(term), locale))
                        }
                        return of(null)
                    }
                )
            ).toPromise()
        const campaignTypeMatch = campaignType ? matchesRegex(lowerCaseQueryText, campaignType.toLowerCase()) : false

        return titleMatch || refNumberMatch || campaignTypeMatch
    }
}